import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, Protected } from "@/context/AuthContext";
import PublicLayout from "@/components/opl/PublicLayout";
import AdminLayout from "@/components/opl/AdminLayout";
import Home from "@/pages/public/Home";
import SquadPoster from "@/pages/SquadPoster";
import ClubPoster from "@/pages/ClubPoster";
import PublicTeams from "@/pages/public/Teams";
import PublicPlayers from "@/pages/public/Players";
import Results from "@/pages/public/Results";
import RulesPage from "@/pages/public/Rules";
import Login from "@/pages/Login";
import LiveDisplay from "@/pages/LiveDisplay";
import Overlay from "@/pages/Overlay";
import OwnerPortal from "@/pages/OwnerPortal";
import Auctioneer from "@/pages/admin/Auctioneer";
import Dashboard from "@/pages/admin/Dashboard";
import Clubs from "@/pages/admin/Clubs";
import Teams from "@/pages/admin/Teams";
import Users from "@/pages/admin/Users";
import Players from "@/pages/admin/Players";
import PlayerForm from "@/pages/admin/PlayerForm";
import Categories from "@/pages/admin/Categories";
import ImportExport from "@/pages/admin/ImportExport";
import AuctionConfig from "@/pages/admin/AuctionConfig";
import RulesAdmin from "@/pages/admin/RulesAdmin";
import Rulebook from "@/pages/admin/Rulebook";
import Squads from "@/pages/admin/Squads";
import BidHistory from "@/pages/admin/BidHistory";
import Reports from "@/pages/admin/Reports";
import Notifications from "@/pages/admin/Notifications";
import AuditLogs from "@/pages/admin/AuditLogs";
import SettingsPage from "@/pages/admin/Settings";

const P = (perms, el) => <Protected perms={perms}>{el}</Protected>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/teams" element={<PublicTeams />} />
            <Route path="/players" element={<PublicPlayers />} />
            <Route path="/results" element={<Results />} />
            <Route path="/rules" element={<RulesPage />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/live" element={<LiveDisplay />} />
          <Route path="/live/:clubId" element={<LiveDisplay />} />
          <Route path="/overlay/:clubId/:kind" element={<Overlay />} />
          <Route path="/poster/:teamId" element={<SquadPoster />} />
          <Route path="/poster/club/:clubName" element={<ClubPoster />} />
          <Route path="/owner" element={P(["bid"], <OwnerPortal />)} />
          <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
            <Route index element={P(["view_reports", "manage_players", "manage_teams"], <Dashboard />)} />
            <Route path="clubs" element={P(["manage_clubs"], <Clubs />)} />
            <Route path="teams" element={P(["manage_teams"], <Teams />)} />
            <Route path="users" element={P(["manage_users"], <Users />)} />
            <Route path="players" element={P(["manage_players"], <Players />)} />
            <Route path="players/new" element={P(["manage_players"], <PlayerForm />)} />
            <Route path="players/:id" element={P(["manage_players"], <PlayerForm />)} />
            <Route path="categories" element={P(["manage_config"], <Categories />)} />
            <Route path="import" element={P(["manage_players"], <ImportExport />)} />
            <Route path="config" element={P(["manage_config"], <AuctionConfig />)} />
            <Route path="live" element={P(["run_auction"], <Auctioneer />)} />
            <Route path="rules" element={P(["manage_rules"], <RulesAdmin />)} />
            <Route path="rulebook" element={P(["manage_rules", "publish_rules"], <Rulebook />)} />
            <Route path="squads" element={P(["view_reports"], <Squads />)} />
            <Route path="bids" element={P(["view_reports"], <BidHistory />)} />
            <Route path="reports" element={P(["view_reports"], <Reports />)} />
            <Route path="notifications" element={P(["manage_notifications"], <Notifications />)} />
            <Route path="audit" element={P(["view_audit"], <AuditLogs />)} />
            <Route path="settings" element={P(["manage_settings"], <SettingsPage />)} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
